export const templates = [
    { id: 1, name: "営業提案テンプレート", description: "営業提案の雛形", createdAt: "2024-06-15" },
    { id: 2, name: "採用面接テンプレート", description: "面接質問テンプレート", createdAt: "2024-06-14" },
    { id: 3, name: "顧客対応テンプレート", description: "顧客対応マニュアル", createdAt: "2024-06-13" },
    { id: 4, name: "レポート作成テンプレート", description: "レポートの基本構成", createdAt: "2024-06-12" },
  ];
  